import * as S from './style';
//icons
import { Check, Info } from '@phosphor-icons/react';

interface IDetails {
    type_product: string,
    count: number,
    code: string,
    value_unit: string,
    amount: number,
    payment: string,
    discount: string,
    auth: string,
    title_promo: string,
    total: string,
    user?: string | null
}
export default function DetailsProduct({
    type_product,
    count,
    code,
    value_unit,
    amount,
    payment,
    discount,
    auth,
    title_promo,
    total,
    user,
}: IDetails) {
    return (
        <S.Container>
            <S.Header>
                <S.Title>{type_product}</S.Title>
                <S.Count>{count}</S.Count>
            </S.Header>
            <S.Content>
                <S.Section>
                    <S.ContentInfor>
                        <S.Infor isTitle={true}>Código</S.Infor>
                        <S.Infor isTitle={false}>{code}</S.Infor>
                    </S.ContentInfor>
                    <S.ContentInfor>
                        <S.Infor isTitle={true}>Valor Unitário</S.Infor>
                        <S.Infor isTitle={false}>{value_unit}</S.Infor>
                    </S.ContentInfor>
                    <S.ContentInfor>
                        <S.Infor isTitle={true}>Quantidade</S.Infor>
                        <S.Infor isTitle={false}>{amount} und.</S.Infor>
                    </S.ContentInfor>
                </S.Section>

                <S.FeaturedContent>
                    <S.TitleFeatured>
                        <Check size={16} />
                        Promoção Aplicada
                    </S.TitleFeatured>
                    <S.Section>
                        <S.ContentInfor>
                            <S.Infor isTitle={true}>Método</S.Infor>
                            <S.Infor className='blue' isTitle={false}>{payment}</S.Infor>
                        </S.ContentInfor>
                        <S.ContentInfor>
                            <S.Infor isTitle={true}>Desconto</S.Infor>
                            <S.Infor className='sucess' isTitle={false}>{discount}</S.Infor>
                        </S.ContentInfor>
                        <S.ContentInfor>
                            <S.Infor isTitle={true}>Aplicada por</S.Infor>
                            <S.Infor isTitle={false}>{auth}</S.Infor>
                        </S.ContentInfor>
                    </S.Section>

                    <S.Section>
                        {
                            user && (
                                <S.ContentInfor>
                                    <S.Infor isTitle={true}>
                                        Autorização
                                    </S.Infor>
                                    <S.Infor className='red' isTitle={false}>{user}</S.Infor>
                                </S.ContentInfor>
                            )
                        }
                        <S.ContentInfor>
                            <S.Infor isTitle={true}>Nome</S.Infor>
                            <S.Infor isTitle={false}>{title_promo}</S.Infor>
                        </S.ContentInfor>
                    </S.Section>
                </S.FeaturedContent>
            </S.Content>

            <S.Footer>Total: {total}</S.Footer>
        </S.Container>
    )
}